@layer module {
.compose-file-input {
            display: none;
    }

.compose-textarea {
            width: 100%;
            resize: none;
            border: none;
            outline: none;
    }

.compose-textarea:disabled {
            opacity: 0.5;
    }

.compose-file-errors {
            display: flex;
            flex-direction: column;
    }

.compose-file-errors--dismissible {
            position: relative;
    }

.compose-remove-action {
            border: none;
            cursor: pointer;
    }

.compose-file-errors-dismiss {
            position: absolute;
    }

.compose-attachments {
            display: flex;
            flex-wrap: wrap;
    }

.compose-attachment-chip {
            display: inline-flex;
            align-items: center;
    }

.compose-inline-row {
            display: flex;
            align-items: flex-end;
    }

.compose-inline-row .compose-textarea {
            flex: 1;
    }
} // layer module










@layer app {
.compose-textarea {
            min-height: $size-80;
            max-height: $size-160;
    }

.compose-file-errors {
            padding: $size-6 $size-16 0;
            gap: $size-3;
    }

.compose-file-errors--dismissible {
            padding-right: $size-28;
    }

.compose-file-error {
            padding: $size-3 $size-8;
            border-radius: $size-4;
    }

.compose-file-errors-dismiss {
            top: $size-6;
            right: 0;
    }

.compose-attachments {
            padding: $size-6 $size-16 0;
            gap: $size-6;
    }

.compose-attachment-chip {
            gap: $size-4;
            border-radius: $size-20;
            padding: $size-3 $size-8;
    }

.compose-remove-file {
            padding: 0;
    }

.compose-inline-row {
            gap: $size-6;
    }

.compose-inline-row .compose-textarea {
            min-height: $size-24;
            max-height: $size-80;
            padding: 0;
    }

.compose-forbidden-chars-hint {
            padding: $size-3 $size-12;
            margin: 0 $size-14;
            border-radius: $size-4;
    }

.compose-textarea {
            background: transparent;
    }

.compose-remove-action {
            background: none;
    }

.compose-textarea {
            border-bottom: 1px solid var(--support-border-subtle);
            padding: $size-12 var(--input-placeholder-inline-inset);
            color: var(--input-container-text);
            font-size: var(--font-size-base);
            line-height: var(--input-placeholder-line-height);
    }

.compose-inline-row .compose-textarea {
            border-bottom: none;
            padding: 0;
            font-size: var(--font-size-base);
            line-height: 1.5;
    }

.compose-file-error {
            font-size: var(--font-size-sm);
            color: var(--support-error-text);
            background: var(--support-error-bg);
    }

.compose-remove-action {
            font-size: var(--font-size-base);
            line-height: 1;
            color: var(--support-icon-muted);
    }

.compose-remove-action:hover {
            color: var(--support-error-text);
    }

.compose-attachment-chip {
            background: var(--support-chip-tint);
            border: 1px solid var(--support-chip-border);
            font-size: var(--font-size-sm);
            color: var(--support-chip-text);
    }

.compose-forbidden-chars-hint {
            font-size: var(--font-size-sm);
            color: var(--support-warning-text);
            background: var(--support-warning-bg);
    }

.compose-char-count {
            font-size: var(--font-size-sm);
            color: var(--support-text-faint);
    }

.compose-char-count.warn {
            color: var(--support-warning-border);
    }
} // layer app
